export class ConfirmModalData {
  warningMessage: string;
  title: string;
  question: string;
  confirm: string;
  confirmCssStyle: string;
}
